const getErrors = (state) => state.errors;

export const isRemovedCollaboratorError = (state) => getErrors(state).removedCollaborator || false;
